import * as React from 'react';
import styled from 'styled-components';
import { TLD, usePageTransition } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';
import { OffCanvasContext, media, themeGet, Flex, Box } from '@packages/ui';

import NavigationTabs from '../../NavigationTabs';
import { Logo } from '../../../components/Logo/Logo';
import { BurgerButton } from '../BurgerButton/BurgerButton';

const APP_TLD = getPublicRuntimeConfig('APP_TLD');

const BurgerMenu = styled(BurgerButton)`
  padding: 0 ${themeGet.space(1)};
  ${media.from.sm`
      padding: 0;
  `}
`;

const NavigationTabsWrapper = styled.div`
  display: none;

  ${media.from.lg`
    display: block;
    margin-top: ${themeGet.space(4)};
    margin-left: ${themeGet.space(2)};
  `}
`;

export const MenuBar: React.FC = React.memo(() => {
  const { toggle, isActive } = React.useContext(OffCanvasContext);
  usePageTransition({
    complete: () => isActive && toggle(),
    error: () => isActive && toggle(),
  });
  return (
    <Flex alignItems="center">
      <BurgerMenu onClick={() => toggle(true)} />
      <Box>
        <Logo />
      </Box>
      {APP_TLD === TLD.DE && (
        <NavigationTabsWrapper>
          <NavigationTabs />
        </NavigationTabsWrapper>
      )}
    </Flex>
  );
});

MenuBar.displayName = 'MenuBar';
